export default __webpack_public_path__ + "static/media/36I-117147_-37341_0.98aefbf0.jpg";